export default function () {
  return function (scope, element, attrs) {
    var action = () => scope.$apply(function (){
      scope.$eval(attrs.clickOrEnter);
    });
    element.bind("click", () => action());
    element.bind("keydown", function (event) {
      if(event.which === 13) { // if 'Enter' key is pressed
        action();
        event.preventDefault();
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/login/click-or-enter.js